const message = {
  Confirm: "Confirm",
  Cancel: "Cancel",
  reset: "reset",
};

export default message;
